import rootReducer from "./reducer"; 
import { configureStore } from "@reduxjs/toolkit";
const store= configureStore({
  reducer:{
    auth:rootReducer
  }
})

export default store;